import { render, staticRenderFns } from "./IdeaStatusBox.vue?vue&type=template&id=c0ee64e6&scoped=true&"
import script from "./IdeaStatusBox.vue?vue&type=script&lang=js&"
export * from "./IdeaStatusBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ee64e6",
  null
  
)

export default component.exports